module.exports = __webpack_public_path__ + "img/weather-blue.55b08d04.svg";